module.exports = __webpack_public_path__ + "img/35.f667da88.svg";